export const GET_TENANTS = "GET_TENANTS";
export const GET_PROSPECTS = "GET_PROSPECTS";
export const EMPTY_TENANTS = "EMPTY_TENANTS";